/* eslint-disable import/first, import/newline-after-import */

import 'utils/drop_down_component/drop_down_component.css';
import 'components/util/scroll-top/scroll-top';
import 'components/global/promos/redirector-app-notice/redirector-app-popover';
import 'components/sessions/login-detected-modal/login-detected-modal';
import 'components/util/countdown-timer/countdown-timer';
import 'components/resources/show/modal-view/modal-view'; // split-test: iscroll_modal

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

// start split-test: iscroll_modal
import ResourceShowModalViewController from 'components/resources/show/modal-view/modal-view-controller';
EezyStimulusApplication.register('resource-show-modal-view', ResourceShowModalViewController);

import(/* webpackChunkName: "drop-down-component-controller" */ 'utils/drop_down_component/drop-down-component-controller')
  .then((controller) => {
    EezyStimulusApplication.register('ez-drop-down', controller.default);
  });

import ScrollTopController from 'components/util/scroll-top/scroll-top-controller';
EezyStimulusApplication.register('scroll-top', ScrollTopController);

import ToggleClassController from 'controllers/toggle-class-controller';
EezyStimulusApplication.register('toggle-class', ToggleClassController);

import RichTextController from 'components/util/rich-text/rich-text-controller';
EezyStimulusApplication.register('rich-text', RichTextController);
